import React from "react";
import { Link } from "react-router-dom";

const jobs = [
  {
    id: "1",
    title: "PHP Developer/Backend Developer",
    location: "Noida, Uttar Pradesh",
    experience: "Mid-Senior (Min 2 years)",
    type: "Full-Time - On-Site",
    skills: ["PHP", "jQuery", "GitHub", "Codeigniter", "CakePHP", "SQL", "Node.js", "React.js"],
  },
  {
    id: "2",
    title: "Key Account Manager",
    location: "Noida, Uttar Pradesh",
    experience: "Mid-Senior (Min 2 years)",
    type: "Full-Time - On-Site",
    skills: ["Client Servicing", "Account Management", "Negotiation", "6+ More"],
  },
  {
    id: "3",
    title: "BDM - Acquisition Domestic Sales",
    location: "Noida, Uttar Pradesh",
    experience: "Mid-Senior (Min 2 years)",
    type: "Full-Time - On-Site",
    skills: ["Client Acquisition", "Sales Prospecting (Hunting)", "Revenue Generation", "4+ More"],
  },
  {
    id: "4",
    title: "BDM - Acquisition International Sales",
    location: "Noida, Uttar Pradesh",
    experience: "Mid-Senior (Min 2 years)",
    type: "Full-Time - On-Site",
    skills: ["Global Business Developmen", "B2B Sales", "Networking", "+3 More"],
  },
];

const JobList = () => {
  return (
    <div className="row">
      {jobs.map((job) => (
        <div key={job.id} className="col-xl-4 col-md-6">
          <Link to={`/apply?search=${job.id}`}>
            <div className="box-content">
              <p className="f-16 fw-500">{job.title}</p>
              <p className="f-12">{job.location}</p>
              <div className="d-flex justify-content-md-between">
                <p className="f-12">
                  <span className="fw-500">{job.experience}</span>
                </p>
                <p className="f-12">
                  <span className="fw-500">{job.type}</span>
                </p>
              </div>
              <div className="skills">
                {job.skills.map((skill, i) => (
                  <div key={i} className="badge badge-secondary">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default JobList;
